import React from 'react';
import ReactSVG from 'react-svg';

export const IconNames = {
  SortDown: 'sort-down.svg',
  SortUp: 'sort-up.svg',
  SortRight: 'sort-right.svg',
  Cancel: 'cancel.svg',
  ArrowUp: 'up-arrow.svg',
  Checked: 'checked.svg',
  ArrowRight: 'arrow-right.svg'
};

export default class Icons extends React.Component {
  getIconPath = iconName => {
    //const path = '/icons/';
    const path = 'https://static.samskip.com/voyager-schedule/icons/';
    return path + iconName;
  };

  renderIcon() {
    return (
      <ReactSVG
        path={this.getIconPath(this.props.iconName)}
        svgClassName={this.props.iconClassName}
        className={this.props.className}
        onClick={this.props.onClick}
      />
    );
  }

  render() {
    if (this.props.onClick) {
      return <a href="javascript:void(0)">{this.renderIcon()}</a>;
    }

    return this.renderIcon();
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/icons.js